import PlaylistAddedIcon from '@atlaskit/icon-lab/core/playlist-added';
import * as React from 'react';

export function SvgPlaylistAdded() {
  return (
    <PlaylistAddedIcon
      label="Playlist added icon"
      testId="ads-refreshed-icon"
    />
  );
}
